import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Paper,
  CardHeader,
  Avatar
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { orange } from '@material-ui/core/colors';
import AddIcon from '@material-ui/icons/Add';
import assigment from '../../global/imagenes/acom_docente.png';

const styles = (theme) => ({});

function InicioNuevo({ classes, onCrearReporte }) {
  return (
    <Grid container direction={'row'} justifyContent={'center'} style={{ paddingTop: 40 }}>
      <Grid item xs={12} sm={8} md={6} lg={6} style={{ padding: '2% 2% 0% 2%' }} onClick={onCrearReporte}>
        <Paper elevation={8} square>
          <Card style={{ maxWidth: "100%", height: '380px', cursor: 'pointer' }} elevation={1}>
            <CardHeader
              avatar={<Avatar aria-label="recipe" style={{ backgroundColor: orange[500] }}>A</Avatar>}
              title={`Acompañamiento Docente`}
            />
            <CardContent>
              <Grid container direction={'row'} justifyContent={'center'}>
                <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'center', height: "150px" }}>
                  <img src={assigment} style={{ width: '150px', maxWidth: '200px', minWidth: '100px', height: "150px" }} alt='Imagen Tipo' />
                </Grid>
                <Grid item xs={12} sm={12} md={12} style={{ padding: "15px 10px 0px 10px" }}>
                  <Typography variant="body2" color="textSecondary" component="p" align='justify'>
                    Aquí puedes crear tu registro de acompañamiento docente.
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(InicioNuevo);